export const route = {
    params: {
        jobId: 'jobId',
    },
    patterns: {
        createNewJobProfile: '/job-profiles/new',
        jobProfileDetails: '/job-profiles/:jobId',
        jobProfileEdit: '/job-profiles/:jobId/edit',
        jobProfiles: '/job-profiles',
    },
    searchParams: {
        navigation: {
            active: 'active',
            all: 'all',
            archived: 'archived',
            draft: 'draft',
        },
        searchTerm: 'search',
        state: 'state',
        tab: 'tab',
    },
} as const;
